import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from 'antd'
import deleteFile from '../actions/deleteFile'
import EditFileAction from './EditFileAction'

class LabelActions extends Component {
    _handleClickDelete = e => {
        e.preventDefault()
        const {fileId, barcode, onFetchFiles} = this.props

        deleteFile(fileId, barcode, onFetchFiles)
    }

    render() {
        const {file, fileId, onFetchFiles, barcode} = this.props

        return (
            <td className='LabelActions'>
                <EditFileAction
                    fileId={fileId}
                    colorspace={file.colorspace}
                    printer={file.printer}
                    onFetchFiles={onFetchFiles}
                    barcode={barcode}
                />
                <Button type='link' className='text-danger' onClick={this._handleClickDelete}>Delete</Button>
            </td>
        )
    }
}

LabelActions.propTypes = {
    fileId: PropTypes.string.isRequired,
    barcode: PropTypes.string.isRequired,
    onFetchFiles: PropTypes.func.isRequired,
    file: PropTypes.object.isRequired,
}

export default LabelActions
